<template>
  <div class="login_container">
    <div class="login_box">
      <!-- 头部区域 -->
      <div class="login_head">
        <i class="logo"></i>
        <h4>确认收货登录</h4>
      </div>
      <div class="code"></div>
      <el-form :model="formLogin" class="login_form">
        <el-form-item>
          <el-input
            v-model="formLogin.customerName"
            placeholder="请输入客户名称"
            prefix-icon="iconfont icon-yonghu"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="formLogin.client"
            placeholder="请输入委托人姓名"
            prefix-icon="iconfont icon-yonghu1"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="formLogin.code"
            placeholder="请输入密码"
            prefix-icon="iconfont icon-zu"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn_login" type="primary" @click="btnClick"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <div class="help">
        <ul class="select-list">
          <li>
            <a href="" class="current">简体</a>
            |
          </li>
          <li>
            <a href="">繁体</a>
            |
          </li>
          <li>
            <a href="">English</a>
            |
          </li>
          <li>
            <a href="">常见问题</a>
          </li>
        </ul>
      </div>
      <p class="nf">
        <span>
          安徽华源医药电子商务公司版权所有-药品信息提供：安徽华源医药集团股份有限公司
          <a href="">
            <span><img src="../assets/image/mi-gongan.png" alt="" /></span>
            备案号：皖B2-20090007-1
          </a>
          -皖-B-2014-0001
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import axios from '../network/axios.js'
export default {
  data() {
    return {
      formLogin: {
        customerName: "",
        client:"",
        code: "",
      },
    };
  },
  methods: {
    btnClick() {
      axios.post("DsApi/GoLoin",this.formLogin,{headers: {'Content-Type': 'application/json'}}).then(res=>{
        if(res.data.isok){
          this.$message.success("登陆成功！")
          window.sessionStorage.setItem("clientID",res.data.data.clientID);
          window.sessionStorage.setItem("customerName",this.formLogin.customerName);
		    window.sessionStorage.setItem("confirmUserName",this.formLogin.client);
          setTimeout(()=>{this.$router.push("/index")},1000);
        }else{
          this.$message.error(res.data.message)      
          }
      })
      
    },
  },
};
</script>

<style>
.login_container {
  background-color: #9ba6b1;
  height: 100%;
}
.login_box {
  position: relative;
  background: #fff;
  width: 854px;
  height: 605px;
  padding: 0 0 20px 0;
  margin: 0 auto;
}
.login_head {
  box-sizing: content-box;
  width: 854px;
  height: 120px;
  padding: 50px 0 22px 0;
  position: relative;
}
.login_head i {
  display: block;
  width: 60px;
  height: 50px;
  background-image: url("../assets//image/mi-logo-3.png");
  background-repeat: no-repeat;
  position: absolute;
  left: 390px;
  top: 50px;
}
.login_head h4 {
  position: absolute;
  left: 330px;
  bottom: 30px;
  font-size: 30px;
  color: #424242;
  font-weight: normal;
  padding-top: 22px;
}
.code {
  position: absolute;
  right: 0;
  top: 0;
  width: 68px;
  height: 68px;
  background-image: url("../assets/image/mi-QRcode.gif");
  background-repeat: no-repeat;
  opacity: 0.3;
}
.code:hover {
  opacity: 1;
}
.login {
  width: 854px;
  height: 333px;
}
.login_form {
  padding: 20px 250px;
}
.btn_login {
  width: 100%;
  display: block;
  margin-bottom: 14px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
.footer {
  height: 80px;
  /* margin-top: -80px;*/
  margin-top: 20px;
  line-height: 1.5;
  text-align: center;
  font-size: 12px;
}
.footer .help {
  text-align: center;
}
.help li {
  display: inline-block;
  color: #fff;
}
.help li a {
  display: inline-block;
  padding: 0 10px;
  color: #fff;
}
.help li a:hover {
  color: #666;
}
.help li .current {
  color: #666;
}

.nf {
  padding: 10px;
  color: #fff;
}
.nf a {
  color: #fff;
}
</style>